export const MonthsMapper = {
  hydrate: months => {
    return (
      (typeof months === "object" &&
        months.map((element, index) => ({
          label: element,
          value: index,
        }))) ||
      []
    );
  },
};
